import { render, staticRenderFns } from "./WebPagesTwoContentBoxesForm.vue?vue&type=template&id=e6fbbe6e&"
import script from "./WebPagesTwoContentBoxesForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesTwoContentBoxesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports